import React from 'react';

import { KeyboardDateTimePicker, KeyboardDatePicker } from "@material-ui/pickers";
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { OutlinedInput } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import {QueryBuilder, CalendarToday, Search as SearchIcon} from '@material-ui/icons';
import FormHelperText from '@material-ui/core/FormHelperText';

import moment, { Moment } from 'moment';
import orderNumberSearchStyles from './orderNumberSearch.module.css';
import fwdStyle from '../forwarderPickupOrder/fwdOrders/fwdOrdersTable.module.css';
import commonStyles from '../common/common.module.css';

import { UserRoleType } from '../../models/User';
import { Badge } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';

import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

import FormControlLabel from '@material-ui/core/FormControlLabel';

const styles = (theme: Theme) =>

  createStyles({
    blue: {
      color: 'var(--primaryblue)',
    },
    searchBtn: {
      borderRadius: ' 50%',
      padding: '0',
      paddingRight: '0 !important',
      minWidth: '28px',
      height: '100%',
      position: 'absolute',
      right: '0px',
      background: 'var(--primaryblue)!important',
    },
    progress: {
      animation: 'none'
    },
    searchBtnTable: {
      minWidth: '30px',
      height: '30px',
      padding: '0',
    },
    textField: {
      color: 'var(--primaryblue)',
      fontSize: '14px'
    },
    disabled: {
      color: 'rgba(0, 0, 0, 0.26)'
    },
    textFieldsDisabled: {
      color: 'rgba(0, 0, 0, 0.26)',
      fontSize: '14px'
    },
    helperText: {
      color: 'red'
    },
    inputSize: {
      padding: '11px 14px',
      '&::placeholder':{
        color: 'grey !important',
        opacity: 1
      }
    },
    textFieldLabel: {
      transform: 'translate(14px, 7px) scale(1)'
    },
    manualEntryBtn: {
      margin: '0px 20px',
      fontSize: '50px'
    },
    checkbox: {
      padding: '0',
      '& svg':{
        fontSize: '20px'
      }
    },
    completeLabel:{
      position: 'absolute',
      top: '-36px',
      right: '0px',
      marginRight: 0,
      '& > span':{
        color: 'var(--primaryblue)',
      fontSize:'13px'
      },
    },
    suspendedLabel:{
      position: 'absolute',
      top: '-36px',
      right: '100px',
      marginRight: 0,
      '& > span':{
        color: 'var(--primaryblue)',
      fontSize:'13px'
      },
    },
    badge: {
      '&>span': {
        marginTop: '11px',
        marginRight: '-17px'
      }
    },
    '@media (max-width:600px)':{
      ipField:{
        marginRight: '0px',
        marginBottom: '15px'
      }
    },
    '@media (max-width:480px)':{
      ipField:{
        marginRight: '0px',
        marginBottom: '15px'
      }
    }
  });



interface OrderNumberSearchProps {
  classes: any;
  startDate: Moment;
  endDate: Moment;
  startTime: string;
  endTime: string;
  keyword: string;
  currDate: boolean;
  errorKeyword: boolean;
  handleChangeDate: (dateType: string, event: any) => void;
  handleChangeTime: (timeType: string, event: any) => void;
  handleChangeKeyword: (event: any) => void;
  search: () => void;
  handleClick: () => void;
  disabledDate: () => void;
  changeFocuses: () => void;
  openModalManualEntry?: () => void;
  userRole: UserRoleType;
  countWaitingList?: number;
  handleOpenWaitingList?: () => void;
  completed: boolean;
  suspended: boolean;
  completeOrders: (type: string) => void;
  progressBar: boolean;
  orderType: string;
};

const orderNumberSearch = (props: OrderNumberSearchProps) => {
  
  const { startDate, endDate, startTime, endTime, keyword, classes, currDate, errorKeyword } = props;
  const numStartTime: number = +startTime.slice(0, 2);
  const numEndTime: number = +endTime.slice(0, 2);
  const equalsTime: boolean = (endTime === '' || (numEndTime - numStartTime >= 0)) ? false : true;
  const equalsDate: boolean = (moment(endDate).format('YYYY-MM-DD') >= moment(startDate).format('YYYY-MM-DD')) ? false : true;
  const range: Function = (start: number, stop: number, step: number = 1) => Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step);
  let colorsClass: string = currDate ? classes.disabled : classes.blue;
  let textFieldClass: string = currDate ? classes.textField : classes.textFieldsDisabled;
  let time: Array<number> = range(0, 24);
  let currTime: number = +(startTime.slice(0, 2));

  function setTimeOptions(period: string): Array<JSX.Element> {

    const timeOptions: Array<JSX.Element> = time.map((item: number, index: number) => {

      let time: string = item.toString() + ':00';
      let valueTime: string = item.toString() + '00';

      if (valueTime.length === 3) {
        valueTime = '0' + valueTime;
      };

      if (time.length === 4) {
        time = '0' + time;
      };

      if (period === 'start') {

        return <option key={index} value={valueTime}>{time}</option>;

      } else {

        return <option key={index} value={valueTime} disabled={item < currTime}>{time}</option>;
      }
    });

    return timeOptions;
  }

  return (

    <div className={ orderNumberSearchStyles.mainWrapper } >

      <div className={[orderNumberSearchStyles.filterWrapper, orderNumberSearchStyles.flexAndRow, orderNumberSearchStyles.justContentSpaceBetween].join(' ')} >

        <div className={[orderNumberSearchStyles.dateTimeWrapper, orderNumberSearchStyles.flexAndRow, orderNumberSearchStyles.justContentSpaceBetween, commonStyles.pt, commonStyles.positionRelative].join(' ')} >
          <Grid container direction="row" wrap="wrap">
            <Grid item xl={5}lg={5} md={5} sm={5} xs={12} className={ orderNumberSearchStyles.griditemOuter }>
              <div className={[orderNumberSearchStyles.dateWrapper, orderNumberSearchStyles.flexAndRow, orderNumberSearchStyles.justContentSpaceBetween].join(' ')} >
                <Grid container direction="row">
                  <Grid item xs={6} className={ orderNumberSearchStyles.gridItem }>
                    <div className={ commonStyles.inputLabel }>From Date</div>
                    <KeyboardDatePicker
                      autoOk
                      className={[ classes.ipField,classes.dateInput ].join(' ')}
                      value={startDate}
                      format={'DD MMM YYYY'}
                      onChange={(date) => props.handleChangeDate('startDate', date)}
                      keyboardIcon={<CalendarToday color={currDate ? 'disabled' : 'primary'} />}
                      InputProps={{ 
                        className: colorsClass ,
                        classes: { root: classes.inputtextField },
                        onClick: props.handleClick 
                      }} 
                      InputLabelProps={{ className: colorsClass }}
                      fullWidth
                      inputVariant='outlined'
                    />
                  </Grid>
                  <Grid item xs={6} className={ orderNumberSearchStyles.gridItem } >
                    <div className={ commonStyles.inputLabel }>To Date</div>
                    <KeyboardDatePicker
                      autoOk
                      className={[ orderNumberSearchStyles.mr, classes.dateInput, classes.ipField ].join(' ')}
                      value={endDate}
                      format={'DD MMM YYYY'}
                      onChange={(date) => props.handleChangeDate('endDate', date)}
                      minDate={startDate}
                      keyboardIcon={<CalendarToday color={currDate ? 'disabled' : 'primary'} />}
                      InputProps={{ 
                        className: colorsClass ,
                        classes: { root: classes.inputtextField },
                        onClick: props.handleClick 
                      }}
                      InputLabelProps={{ className: colorsClass }}
                      fullWidth
                      inputVariant='outlined'
                     />
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xl={5} lg={5} md={5} sm={5} xs={12} className={ orderNumberSearchStyles.griditemOuter }>
              <div className={[orderNumberSearchStyles.timeWrapper, orderNumberSearchStyles.flexAndRow, orderNumberSearchStyles.justContentSpaceBetween].join(' ')} >
                <Grid container direction="row" >
                  <Grid item xs={6} className={ orderNumberSearchStyles.gridItem } >
                    <FormControl fullWidth >
                      <div className={ `${ colorsClass } ${ commonStyles.inputLabel }` }>From Time</div>
                      <Select native
                        onChange={(event) => props.handleChangeTime('startTime', event)}
                        className={[ colorsClass ,classes.inputtextField , classes.timeInput, classes.ipField ].join(' ')}
                        value={startTime}
                        inputProps={{
                          name: 'startTime',
                          id: 'startTime',
                          onClick: props.handleClick,
                          classes: {
                            icon: colorsClass,
                          }
                        }}
                        variant="outlined"
                        IconComponent={QueryBuilder}
                      >
                        <option value='' />
                        {setTimeOptions('start')}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} className={ orderNumberSearchStyles.gridItem }>
                    <FormControl fullWidth className={[classes.ipField,orderNumberSearchStyles.mr].join(' ')} >
                      <div className={ `${ colorsClass } ${ commonStyles.inputLabel }` }>To Time</div>
                      <Select native
                        onChange={(event) => props.handleChangeTime('endTime', event)}
                        className={[ classes.select ,classes.inputtextField , classes.timeInput ].join(' ')}
                        value={endTime}
                        inputProps={{
                          name: 'endTime',
                          id: 'endTime',
                          onClick: props.handleClick,
                          classes: { 
                            icon: colorsClass,
                          }
                        }}
                        variant="outlined"
                        IconComponent={QueryBuilder}
                      >
                        <option value='' />
                        {setTimeOptions('end')}
                      </Select>
                      {equalsTime && <FormHelperText className={ classes.helperText }>End time should not be before start time</FormHelperText>}
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
            </Grid>

            <Grid item className={[classes.completeLabelContainer, commonStyles.mlauto].join(' ')}>
              { props.orderType === 'po' && <FormControlLabel
                value=""
                control={
                  <Checkbox
                    name=''
                    icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                    checkedIcon={<CheckBoxIcon color="primary"/>}
                    classes={{
                      root: classes.checkbox,
                    }}
                    onChange={() => props.completeOrders('suspended') }
                    checked={props.suspended}
                  />
                }
                label={'Show suspended orders'}
                className={classes.suspendedLabel}
              />}
              <FormControlLabel
                value=""
                control={
                  <Checkbox
                    name=''
                    icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                    checkedIcon={<CheckBoxIcon color="primary"/>}
                    classes={{
                      root: classes.checkbox,
                    }}
                    onChange={() => props.completeOrders('completed') }
                    checked={props.completed}
                  />
                }
                label={'Completed'}
                className={classes.completeLabel}
              />
            </Grid>

            <Grid item className={ orderNumberSearchStyles.completed } xs>
              { !props.progressBar && 
                <Button
                  color="primary"
                  variant="contained"
                  onClick={props.search}
                  className={ classes.searchBtnTable }
                  disabled={(equalsTime || equalsDate) && (keyword === '')}
                >
                  <SearchIcon
                    className={[orderNumberSearchStyles.iconSearch, orderNumberSearchStyles.iconSearchInner].join(" ")}/>
                </Button> }
                { props.progressBar && <CircularProgress size={30} className={classes.progress} /> }
            </Grid>
          </Grid>
        </div>

        <div className={[orderNumberSearchStyles.textField, orderNumberSearchStyles.flexAndRow, orderNumberSearchStyles.justContentSpaceBetween, commonStyles.searchWrapperOuter, fwdStyle.fwdSearchField].join(' ')} >
          <TextField
            value={keyword}
            onClick={props.disabledDate}
            onBlur={props.changeFocuses}
            variant="outlined"
            onChange={props.handleChangeKeyword}
            error={errorKeyword}
            helperText={errorKeyword ? 'Enter more than 3 characters' : ''}
            className={ commonStyles.searchWrapper }
            InputProps={{
              className: [textFieldClass, commonStyles.searchIpField].join(' '),
              classes: { input: classes.inputSize }
            }}
            InputLabelProps={{ className: [textFieldClass, classes.textFieldLabel].join(' ') }}
            placeholder= 'Order or AWB'
          />

          <Button
            color="primary"
            variant="contained"
            onClick={props.search}
            className={ commonStyles.searchBtn }
            disabled={(equalsTime || equalsDate) && (keyword === '')}
          >
            <SearchIcon
              className={ commonStyles.iconSearch }/>
          </Button>
        </div>
      </div>
    </div>

  )
};

export default withStyles(styles)(orderNumberSearch);